import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import PrepFireBudgetCalculator from 'common/requestDetails/prepFire/PrepFireBudgetCalculator';

const BUDGET_LOCAL_PATH = 'budget';
const BUDGET_APPSHARE_PATH = 'share.appShare';

export class PrepFireBudgetListener extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      savingBudget: false,
    };
    this.loggingOn = false;
  }

  setLoggingOn(bool) {
    this.loggingOn = bool;
  }

  saveBudget = (newBudget) => {
    this.loggingOn && console.log(`*** saving entity budget data... `);
    // Broke down to several calls due to ovewriding issue when add non fed share in Budget Summary Table
    const basePath = this.props.entityDataPath || `context.${this.props.entityType}`;
    const customBudgetPayloadPath = this.props.customBudgetPayloadPath
      ? `.${this.props.customBudgetPayloadPath}`
      : '';
    const budgetPath = `${basePath}.payload${customBudgetPayloadPath}.budget`;
    this.loggingOn && console.log(`** budgetPath = ${budgetPath}`);
    // Saving share
    this.props.saveEntityData(
      `${budgetPath}.share`,
      this.props.entityType,
      newBudget.share,
      BUDGET_LOCAL_PATH
    );
    // Saving budget summary
    this.props.saveEntityData(
      `${budgetPath}.budgetSummary`,
      this.props.entityType,
      newBudget.budgetSummary,
      BUDGET_LOCAL_PATH
    );
    // Saving extras
    this.props.saveEntityData(
      `${budgetPath}.extras`,
      this.props.entityType,
      newBudget.extras,
      BUDGET_LOCAL_PATH
    );

    /*
     * Comment in legacy code around this area stated:
     * TODO: this should be serialized to after server response via promise but
     * works with current low contention usage pattern
     */
    this.loggingOn && console.log(`** about to invoke setSate({savingBudget: false})`);
    this.setState({savingBudget: false}, () => {
      this.loggingOn &&
        console.log(
          `* setState(...) finished setting savingBudget to false:  this.state.savingBudget=${this.state.savingBudget}`
        );
    });
  };

  shouldSaveBudget = (newBudget, oldBudget) => {
    let newShare = _.get(newBudget, 'share');
    let oldShare = _.get(oldBudget, 'share');
    let sharesDiffer = !_.isEqual(newShare, oldShare);
    this.loggingOn &&
      sharesDiffer &&
      console.log(
        ` newShare=${JSON.stringify(newShare)},\n oldShare=${JSON.stringify(oldShare)}`
      );

    let newSummary = _.get(newBudget, 'budgetSummary');
    let oldSummary = _.get(oldBudget, 'budgetSummary');
    let summariesDiffer = !_.isEqual(newSummary, oldSummary);
    this.loggingOn &&
      summariesDiffer &&
      console.log(
        ` newSummary=${JSON.stringify(newSummary)}\n oldSummary=${JSON.stringify(
          oldSummary
        )}`
      );

    let newExtras = _.get(newBudget, 'extras');
    let oldExtras = _.get(oldBudget, 'extras');
    let extrasDiffer = !_.isEqual(newExtras, oldExtras);
    this.loggingOn &&
      extrasDiffer &&
      console.log(
        ` newExtras=${JSON.stringify(newExtras)},\n oldExtras=${JSON.stringify(
          oldExtras
        )}`
      );

    const shouldUpdate = sharesDiffer || summariesDiffer || extrasDiffer;
    this.loggingOn &&
      !shouldUpdate &&
      console.log(`No need to save budget... share and budgetSummary have not changed.`);
    return shouldUpdate;
  };

  doNotProceed(calculator) {
    /*
     * AFG FOs make use of rules that requires org type and either popoluation size
     * or applicant's state in order to determine appRate.  When just starting an
     * application you haven't entered that data, so you won't end up with a
     * normalized config having appRates properties for each of its fundingStreamTypes
     */
    const notNormalized = !calculator.isNormalizedConfig;
    /*
     * If you don't have funding streams, there is nothing to get an app share of, so
     * newly started applications can skip calculating appShare until fundingStreams
     * exist which will contain the cost items from which you get totals and determine
     * appShare, fedShare.
     *
     * Amendments that are not Budget or Scope also do not have fundingStreams property
     * (under payload.grantAmendment)
     */
    const noFundingStreams = _.isEmpty(calculator.fundingStreams);
    /*
     * Wait until the saving of budget is finished before calculating and saving a new
     * budget.
     */
    const budgetSaveInProgress = this.state.savingBudget;
    const haveReasonToNotProceed =
      notNormalized || noFundingStreams || budgetSaveInProgress;
    this.loggingOn &&
      haveReasonToNotProceed &&
      console.log(
        `doNotProceed flags: notNormalized=${notNormalized}, noFundingStreams=${noFundingStreams}, budgetSaveInProgress=${budgetSaveInProgress}`
      );

    return haveReasonToNotProceed;
  }

  customMerge = (obj1, obj2) => {
    return _.mergeWith(obj1, obj2, (srcVal, objVal) => {
      //if source is array and incoming is plain object, assign instead of merge
      if (_.isArray(srcVal) && _.isPlainObject(objVal)) {
        return objVal;
      }
      //for everything else, let _.merge handle normally as deep merge
      return undefined;
    });
  };

  componentDidUpdate(prevProps) {
    const {
      budget,
      budgetCalcConfig,
      totalerType,
      fundingStreams,
      costShareInfo,
      appData,
      messageOverride,
      fedShareAdjustments,
      toggles,
    } = this.props;
    const appShare = _.get(budget, BUDGET_APPSHARE_PATH); // needed for approved cost share waivers

    this.loggingOn &&
      console.log(
        `\n*** PrepFireBudgetListener firing *** appShare=${JSON.stringify(
          appShare
        )}, fedShareAdjustments=${JSON.stringify(fedShareAdjustments)}`
      );

    const calculator = new PrepFireBudgetCalculator(
      budgetCalcConfig,
      totalerType,
      fundingStreams,
      costShareInfo,
      appShare,
      appData,
      fedShareAdjustments,
      toggles
    );
    if (this.doNotProceed(calculator)) {
      /*
       * Before we bail, check if we have a budget object,
       * and if not, save an inital copy.  The BudgetSummaryTable
       * component won't render without a truthy budget
       */
      if (!budget) {
        this.setState({savingBudget: true}, () =>
          this.saveBudget({budgetSummary: {}, share: {}})
        );
      }
      return;
    }

    this.loggingOn && console.log(`Proceeding with calculation.`);
    const prevBudgetClone = _.cloneDeep(prevProps.budget);
    const newBudgetObj = calculator.computeBudgetObj();
    /* check for message override and apply it.
     * If a message configured in the fundingOpportunityConfig.json file is returned
     * in newBudgetObj and it has a key that is contained in a messageOverride
     * object passed in as props, then use that message object instead of object in foConfig.json
     */
    const msgKey = _.get(newBudgetObj, 'extras.message.key');
    const overriddenMsg = _.get(messageOverride, msgKey);
    if (!_.isEmpty(overriddenMsg)) {
      const origMsg = _.get(newBudgetObj, 'extras.message');
      console.log(
        `Overriding original message (${JSON.stringify(
          origMsg
        )}) with overriddenMsg (${JSON.stringify(overriddenMsg)}`
      );
      _.set(newBudgetObj, 'extras.message', overriddenMsg);
    }
    /*
     * Keeping with the persisted output of legacy code,
     * we are weeding out some properties from the returned
     * value above to only keep those we want to persist.
     * Properties we are not interested in, are:
     * total, numPeriods, and share.totalShare.
     */
    const newBudgetObjWithOnlyPropsWeWantToPersist = {
      share: {
        appShare: _.get(newBudgetObj, 'share.appShare'),
        fedShare: _.get(newBudgetObj, 'share.fedShare'),
        appRate: _.get(newBudgetObj, 'share.appRate'),
        fedRate: _.get(newBudgetObj, 'share.fedRate'),
      },
      extras: newBudgetObj.extras,
      budgetSummary: newBudgetObj.budgetSummary,
    };
    // update original copy of budget with values coming back from calculator
    let newBudget = this.customMerge(
      prevBudgetClone,
      newBudgetObjWithOnlyPropsWeWantToPersist
    );
    // ensure any prior error message gets reset if it no longer exists
    _.set(newBudget, 'extras.message', _.get(newBudgetObj, 'extras.message'));
    if (this.shouldSaveBudget(newBudget, prevProps.budget)) {
      this.setState({savingBudget: true}, () => {
        this.loggingOn &&
          console.log(
            `setState(..) finished setting savingBudget to true: this.state.savingBudget=${this.state.savingBudget}`
          );
        this.saveBudget(newBudget);
      });
    }
  }

  render = () => null;
}
export const mapStateToProps = (state) => ({
  toggles: state.toggles.toggles,
});
export default connect(mapStateToProps)(connectDynamic(PrepFireBudgetListener));
